var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"box-card",staticStyle:{"width":"50%","margin-left":"30%"}},[_c('h4',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3050e4d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/intro1.vue
// module id = null
// module chunks = 